module.exports = __webpack_public_path__ + "static/media/icon_aws-s3.433782ab.svg";